module.exports = __webpack_public_path__ + "img/d3b0fa012334e0476afe1480da07cc46-enable_2fa_3.png";